import DTM from 'shared/helpers/DTM';

export const trackSelectedBottomNavState = (bnState: string) => {
  DTM.updateDatalayer({ selectedBottomNavState: bnState });
};
